/**
 * DPC Toast - Système de notifications
 * Usage: DPC.toast(message, type, duration)
 * Types: success, error, warning, info
 * Durée par défaut: 4500ms
 */

window.DPC = window.DPC || {};

// Fonction principale
window.DPC.toast = function (arg1, arg2, arg3) {
  let type, message, duration;
  const DEFAULT_DURATION = 4500;
  const VALID_TYPES = ["success", "error", "warning", "info"];

  // Format: DPC.toast(type, message, duration) - type est un type valide
  if (VALID_TYPES.includes(arg1) && typeof arg2 === "string") {
    type = arg1;
    message = arg2;
    duration = arg3 || DEFAULT_DURATION;
  }
  // Format: DPC.toast(message, type)
  else if (typeof arg1 === "string") {
    message = arg1;
    type = VALID_TYPES.includes(arg2) ? arg2 : "success";
    duration = arg3 || DEFAULT_DURATION;
  }
  // Fallback
  else {
    message = arg1 || "Notification";
    type = "info";
    duration = DEFAULT_DURATION;
  }

  const container = document.getElementById("toaster-container");
  if (!container) {
    return;
  }

  const toast = document.createElement("div");
  toast.className = `toast toast-${type}`;

  // Icônes selon le type (pas d'icône pour error : évite la confusion avec la croix de fermeture)
  const icons = {
    success: "✓",
    warning: "⚠",
    info: "ℹ",
  };

  // Construction DOM sécurisée (évite XSS via innerHTML)

  const messageSpan = document.createElement("span");
  messageSpan.className = "toast-message";
  messageSpan.textContent = message;

  if (icons[type]) {
    const iconSpan = document.createElement("span");
    iconSpan.className = "toast-icon";
    iconSpan.textContent = icons[type];
    toast.appendChild(iconSpan);
  }
  toast.appendChild(messageSpan);

  container.appendChild(toast);

  // Animation d'entrée
  setTimeout(() => {
    toast.classList.add("show");
  }, 10);

  // Auto-suppression
  setTimeout(() => {
    toast.classList.add("hide");
    setTimeout(() => {
      if (toast.parentElement) {
        toast.remove();
      }
    }, 300);
  }, duration);

  return toast;
};

// Raccourcis pratiques
window.DPC.toaster = {
  success: (message, duration) => window.DPC.toast("success", message, duration),
  error: (message, duration) => window.DPC.toast("error", message, duration),
  warning: (message, duration) => window.DPC.toast("warning", message, duration),
  info: (message, duration) => window.DPC.toast("info", message, duration),
};
